export const INIT_PROFILE = 'INIT_PROFILE';
export const SET_PROFILE = 'SET_PROFILE';
export const INIT_REPOS = 'INIT_REPOS';
export const SET_REPOS = 'SET_REPOS';
export const FULL_NAV_MENU = 'FULL_NAV_MENU';
export const OPEN_NAV_MENU = 'OPEN_NAV_MENU';
export const CLOSE_NAV_MENU = 'CLOSE_NAV_MENU';
export const TOGGLE_NAV_MENU = 'TOGGLE_NAV_MENU';
export const TRIGGER_LOAD_ANIMATION = 'TRIGGER_LOAD_ANIMATION';
export const TRIGGER_LOAD_ANIMATION_DONE = 'TRIGGER_LOAD_ANIMATION_DONE';
export const HIDE_LOAD_ANIMATION = 'HIDE_LOAD_ANIMATION';
export const REQUEST_FAILED = 'REQUEST_FAILED';



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js